import { invoiceLocaleToLanguage } from '../../invoices/constants/invoiceLocaleToLanguage'
import { Contact } from '../types/contact'
import { CustomerForm } from '../types/customerForm'
import { getBaseCustomerPayload } from './getBaseCustomerPayload'

export const getCreateCustomerPayload = (
  customerFormValues: CustomerForm,
  organizationId: string | undefined,
  shippingAddressId?: string,
): Partial<Contact> => {
  const { businessId, contactPersons, currency, customerNumber, language, paymentTerm, phone } = customerFormValues

  const contactNo = customerNumber ? String(customerNumber) : ''
  const invoicingLanguage = language && invoiceLocaleToLanguage[language]

  return {
    ...getBaseCustomerPayload(customerFormValues),
    contactNo,
    contactPersons,
    currencyId: currency,
    invoicingLanguage,
    isCustomer: true,
    isSupplier: false,
    organizationId,
    paymentTermsDays: paymentTerm,
    phone,
    registrationNo: businessId,
    ...(typeof paymentTerm === 'number' ? { paymentTermsMode: 'net' } : {}),
    ...(shippingAddressId ? { shippingAddressId } : {}),
  }
}
